import React, { FormEvent, useState } from "react"
import { AppFunctionComponent } from "../../../../../types"
import { CustomFormProps, InputLabel } from "./custom-form.interface"
import { NewsletterTick } from "../../../newsletter.component"
import useCustomFetch from "../../../../../hooks/use-custom-fetch.hook"
import { isEmail, validateCustomInput } from "../../../../../helpers/validators"
import {
  StyledCustomForm,
  StyledCustomFormButton,
  StyledCustomFormSection,
} from "./custom-form.styled"
import CustomFormInputResolver from "./custom-form-input.resolver"
import useTranslationHook from "../../../../../hooks/use-translation.hook"

const CustomForm: AppFunctionComponent<CustomFormProps> = ({ config }) => {
  const initialFormsState = Object.fromEntries(
    config.form.fields.map((input) => [input.label, ""])
  )
  const { error, loading, subscribe } = useCustomFetch<{
    [key: string]: string | boolean | undefined
  }>("/send-form-email")
  const [formState, setFormState] = useState<{
    [key: string]: string | boolean
  }>(initialFormsState)
  const [validationErrors, setValidationErrors] = useState<{
    [key: string]: string
  }>(initialFormsState)
  const [subscribed, setSubscriptionSuccess] = useState(false)
  const { translate } = useTranslationHook()

  const setInitialInputsState = () => {
    setFormState(initialFormsState)
  }

  const onSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault()
    const isValid = config.form.fields.every((input) => {
      if (input.required) {
        if (input.label === InputLabel.Email) {
          return (
            formState[input.label] !== "" &&
            isEmail(formState[input.label] as string)
          )
        }
        return formState[input.label] !== "" && formState[input.label] !== false
      }
      return true
    })

    if (isValid) {
      await subscribe({
        ...formState,
        targetEmail: config.form.targetEmail,
        id: config.form.id,
      })
      void setSubscriptionSuccess(true)
      !error && !loading && setInitialInputsState()
    } else {
      config.form.fields.forEach(
        (input) =>
          void validateCustomInput(
            input.label,
            formState[input.label],
            input.required,
            setValidationErrors
          )
      )
      void setSubscriptionSuccess(false)
    }
  }

  return (
    <StyledCustomFormSection>
      <StyledCustomForm onSubmit={onSubmit}>
        {config.form.fields.map((field) => (
          <CustomFormInputResolver
            key={field.id}
            field={field}
            formState={formState}
            validationErrors={validationErrors}
            setFormState={setFormState}
            setValidationErrors={setValidationErrors}
          />
        ))}
        <StyledCustomFormButton
          subscribe={false}
          success={subscribed && !error}
          error={subscribed && (error as boolean)}
          type="submit"
          pending={loading}
        >
          {subscribed && !error ? (
            <>
              <NewsletterTick alt="Success tick" /> {translate("Sent")}
            </>
          ) : subscribed && error ? (
            translate("Something went wrong")
          ) : (
            translate("Submit")
          )}
        </StyledCustomFormButton>
      </StyledCustomForm>
    </StyledCustomFormSection>
  )
}

export default CustomForm
